import React, { useEffect, useState } from 'react';
import CurrentTextTag from 'components/etc/CurrentTextTag';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import DropZoneSound from 'components/dropzoneUpload/DropZoneSound';
import { Form } from 'antd';
import SmallModal from 'components/form/SmallModal';
import SubmitButton from 'components/button/SubmitButton';
import VerticalForm from 'components/form/DefaultForm';
import { platformSoundUpdate } from 'apis/operation/platformSoundApis';

/**
 *
 * @returns {플랫폼 사운드 수정 모달}
 */
const PlatformSoundUpdateModal = ({
  visible,
  setVisible,
  fetchData,
  optionList,
  selectSoundType,
  setSelectSoundType,
  record,
}) => {
  const [inputDatas, setInputDatas] = useState({
    sound_name: '',
    sound_type: 'se',
    game_volume: 1,
    sound_id: -1,
  });
  const [file, setFile] = useState(null);
  const [form] = Form.useForm();

  const handleClose = () => {
    setVisible(false);
  };

  /// 사운드 타입 드롭다운
  const handleChangeSoundType = (value) => {
    setSelectSoundType(value);
  };

  /// 사운드명 입력
  const handleInputName = (e) => {
    setInputDatas({ ...inputDatas, sound_name: e.target.value });
  };

  /// 사운드 볼륨
  const handleInputVolume = (value) => {
    setInputDatas({ ...inputDatas, game_volume: value });
  };

  /// 사운드명 태그 닫기
  const handleCloseTag = () => {
    setInputDatas({ ...inputDatas, sound_url: '' });
  };
  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append('uploadFile', file);
    formData.append('sound_name', inputDatas.sound_name);
    formData.append('sound_type', inputDatas.sound_type);
    formData.append('game_volumn', inputDatas.game_volume);
    formData.append('sound_id', inputDatas.sound_id);
    const res = await platformSoundUpdate(formData);
    // console.log(res);
    setVisible(false);
    setFile(null);
    form.resetFields(); // 드롭존 이미지를 비우기 위해 필요하다.
    fetchData();
  };
  useEffect(() => {
    console.log(record);
    if (record) {
      setInputDatas(record);
    }
  }, [visible]);
  return (
    <SmallModal
      title='플랫폼 사운드 수정'
      visible={visible}
      onCancel={handleClose}
    >
      <VerticalForm form={form} drop>
        <Form.Item label='사운드 타입'>
          <DefaultSelect
            optionList={optionList}
            value={inputDatas.sound_type}
            onChange={handleChangeSoundType}
          />
        </Form.Item>
        <Form.Item label='사운드 이름'>
          <DefaultInput
            name='sound_name'
            value={inputDatas.sound_name}
            onChange={handleInputName}
          />
        </Form.Item>
        <Form.Item label='사운드 볼륨'>
          <DefaultInput
            name='game_volume'
            value={inputDatas.game_volume}
            onChange={handleInputVolume}
            type='number'
          />
        </Form.Item>

        <Form.Item name='uploadFile'>
          {inputDatas?.sound_url ? (
            <CurrentTextTag
              text={record?.sound_name}
              onClose={handleCloseTag}
            />
          ) : (
            <DropZoneSound setFile={setFile} />
          )}
        </Form.Item>
        <SubmitButton onClick={handleSubmit}>등록하기</SubmitButton>
      </VerticalForm>
    </SmallModal>
  );
};

export default PlatformSoundUpdateModal;
